import { render, staticRenderFns } from "./PinnedChartReport.vue?vue&type=template&id=1fcd0071&scoped=true"
import script from "./PinnedChartReport.vue?vue&type=script&lang=ts"
export * from "./PinnedChartReport.vue?vue&type=script&lang=ts"
import style0 from "./PinnedChartReport.vue?vue&type=style&index=0&id=1fcd0071&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcd0071",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,ComplianceStatus: require('/app/components/Reports/ComplianceStatus.vue').default,ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,PinnableReportsList: require('/app/components/Reports/PinnableReportsList.vue').default,DateRangePicker: require('/app/components/Reports/DateRangePicker.vue').default,ReportChartLegend: require('/app/components/Reports/ReportChartLegend.vue').default,ZChart: require('/app/components/zeal/ZChart/ZChart.vue').default,ChartContainer: require('/app/components/Reports/ChartContainer.vue').default})
